import {MacOSCursor} from '@remotion/mac-cursors';
import {Video} from '@remotion/media';
import {
	AbsoluteFill,
	Easing,
	interpolate,
	Interactive,
	useVideoConfig,
	useCurrentFrame,
} from 'remotion';

const StudioPlaybackRateCapture = () => {
	const {fps} = useVideoConfig();
	const frame = (useCurrentFrame() * 30) / fps;

	return (
		<AbsoluteFill
			name="Canvas Capture"
			durationInFrames={(639 / 30) * fps}
			style={{
				width: 2560,
				height: 1278,
				scale: 0.889,
				translate: '-58.6px -50.2px'
			}}
		>
			<Video
				src="https://remotion.media/studio-close-ups/playback-rate-retake-7511ab18b073.mp4"
				muted
				durationInFrames={(639 / 30) * fps}
				style={{
					position: 'absolute',
				}}
			/>
			<MacOSCursor
				cursor={interpolate(
					frame,
					[
						12, 52, 58, 60, 66, 76, 100, 101, 106, 110, 112, 119, 137, 139, 144,
						145, 209, 211, 212, 218, 257, 279, 462, 463, 468, 471, 474, 475,
						476, 480, 482, 575, 591, 592,
					],
					[
						'auto',
						'default',
						'auto',
						'default',
						'ew-resize',
						'auto',
						'col-resize',
						'auto',
						'ew-resize',
						'auto',
						'default',
						'ew-resize',
						'default',
						'auto',
						'custom',
						'auto',
						'col-resize',
						'auto',
						'default',
						'ew-resize',
						'text',
						'auto',
						'col-resize',
						'auto',
						'ew-resize',
						'default',
						'ew-resize',
						'default',
						'auto',
						'default',
						'ew-resize',
						'auto',
						'default',
						'auto',
					],
					{
						easing: Easing.step1,
						extrapolateLeft: 'clamp',
						extrapolateRight: 'clamp',
					},
				)}
				customCursor={
					'url("data:image/svg+xml,%3Csvg%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2032%2032%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%3Cg%20filter%3D%22url(%23shadow)%22%3E%0A%3Cpath%20d%3D%22M23%204.5H18C16.9%204.5%2016%205.4%2016%206.5V25.5C16%2026.6%2016.9%2027.5%2018%2027.5H23%22%20stroke%3D%22white%22%20stroke-width%3D%225%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%0A%3Cpath%20d%3D%22M23%204.5H18C16.9%204.5%2016%205.4%2016%206.5V25.5C16%2026.6%2016.9%2027.5%2018%2027.5H23%22%20stroke%3D%22black%22%20stroke-width%3D%222.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%0A%3C%2Fg%3E%0A%3Cdefs%3E%0A%3Cfilter%20id%3D%22shadow%22%20x%3D%220%22%20y%3D%220%22%20width%3D%2232%22%20height%3D%2232%22%20filterUnits%3D%22userSpaceOnUse%22%3E%0A%3CfeDropShadow%20dx%3D%220%22%20dy%3D%221.5%22%20stdDeviation%3D%221%22%20flood-color%3D%22black%22%20flood-opacity%3D%220.35%22%2F%3E%0A%3C%2Ffilter%3E%0A%3C%2Fdefs%3E%0A%3C%2Fsvg%3E") 12 12, e-resize'
				}
				style={{
					position: 'absolute',
					left: 0,
					top: 0,
					scale: interpolate(
						frame,
						[0, 230, 255, 289, 292, 492, 571, 613, 616],
						[
							3.132995506262549, 2.819695955636294, 3.132995506262549,
							2.819695955636294, 3.132995506262549, 2.819695955636294,
							3.132995506262549, 2.819695955636294, 3.132995506262549,
						],
						{
							easing: Easing.step1,
							extrapolateLeft: 'clamp',
							extrapolateRight: 'clamp',
						},
					),
					translate: interpolate(
						frame,
						[
							12, 13, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30,
							31, 32, 33, 34, 35, 36, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52,
							53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68,
							69, 70, 71, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85,
							86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101,
							102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114,
							115, 116, 117, 118, 119, 120, 121, 122, 123, 124, 136, 137, 138,
							139, 140, 141, 142, 143, 144, 145, 146, 148, 149, 150, 151, 152,
							153, 154, 155, 156, 157, 158, 159, 160, 161, 162, 163, 164, 167,
							168, 169, 170, 171, 172, 173, 174, 175, 176, 177, 178, 179, 180,
							181, 188, 189, 190, 191, 192, 193, 194, 200, 201, 202, 203, 204,
							205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217,
							218, 219, 220, 221, 222, 223, 224, 256, 257, 258, 259, 260, 261,
							262, 263, 264, 265, 266, 267, 268, 269, 270, 271, 272, 273, 274,
							275, 276, 278, 279, 280, 281, 282, 291, 292, 293, 294, 295, 296,
							297, 298, 310, 311, 312, 313, 314, 315, 316, 317, 318, 323, 324,
							325, 326, 327, 328, 329, 330, 331, 332, 333, 334, 335, 336, 337,
							338, 339, 352, 353, 354, 355, 356, 357, 358, 359, 360, 361, 362,
							363, 364, 374, 375, 376, 377, 378, 381, 382, 383, 384, 385, 386,
							400, 401, 402, 403, 407, 408, 409, 410, 411, 412, 413, 455, 456,
							457, 458, 459, 460, 461, 462, 463, 464, 465, 466, 467, 468, 469,
							470, 471, 472, 473, 474, 475, 476, 477, 478, 479, 480, 481, 482,
							483, 484, 485, 486, 487, 493, 494, 495, 496, 497, 498, 499, 500,
							501, 502, 503, 504, 505, 506, 507, 508, 509, 510, 511, 512, 513,
							514, 515, 516, 517, 518, 519, 520, 521, 522, 523, 524, 525, 526,
							527, 528, 529, 530, 531, 532, 533, 534, 535, 536, 537, 538, 539,
							540, 541, 542, 543, 544, 545, 546, 547, 548, 549, 550, 551, 552,
							553, 558, 559, 560, 574, 575, 586, 587, 588, 589, 590, 591, 592,
							593, 594, 595, 596, 597, 598, 599, 600, 601, 602, 603, 604, 605,
							606, 607, 608, 609, 610,
						],
						[
							'2563.365522516493px 1275.3494597953916px',
							'2584.0604264270005px 1279.8409025719475px',
							'2584.0604264270005px 1279.8409025719475px',
							'2585.4311119609906px 1281.2115881059374px',
							'2584.9293431494407px 1279.926570417822px',
							'2504.548427191892px 1242.318386078975px',
							'2243.726551295535px 1157.5928865092264px',
							'1670.6331389234151px 1027.7571469547759px',
							'1276.8914810211302px 944.1575676450904px',
							'913.7699588870829px 865.7102973515632px',
							'809.8303853140835px 844.4401950473276px',
							'742.6300793574911px 823.818720718998px',
							'684.4371354814035px 797.3718328712114px',
							'636.1694234630462px 767.3391337603978px',
							'577.6093316760685px 716.0240940816522px',
							'570.9639544889569px 701.3748924371355px',
							'570.3275647767473px 692.0615737642222px',
							'570.3275647767473px 692.0615737642222px',
							'1708.5717563820633px 368.6042642700067px',
							'3992.745769193996px -173.9546801797495px',
							'3992.745769193996px -173.9546801797495px',
							'4863.485992924754px -475.8848838321063px',
							'4863.485992924754px -475.8848838321063px',
							'4930.0009561143515px -824.3816808490295px',
							'4837.5531121522135px -900.3935366669854px',
							'4792.455110431208px -929.0800267712018px',
							'4751.726168849795px -950.8274213595946px',
							'4743.734582656086px -954.3275647767473px',
							'4727.2129266660295px -956.4814991873028px',
							'4687.414093125538px -958.6599101252509px',
							'4664.051247729229px -960.8260827995028px',
							'4653.367243522325px -963.8856487235873px',
							'4619.1735347547565px -980.0034420116646px',
							'4601.758485514868px -990.699684482264px',
							'4569.082321445645px -1007.0377665168754px',
							'4554.751314657233px -1013.57299933072px',
							'4552.4138062912325px -1018.1990630079357px',
							'4544.43445836122px -1026.5945119036237px',
							'4544.43445836122px -1026.5945119036237px',
							'4536.369442585333px -1032.4444019504733px',
							'4521.536666985371px -1045.3068170953245px',
							'4515.686776938522px -1048.4642891289798px',
							'4514.7321923702075px -1048.9660579405297px',
							'4509.396309398604px -1049.737068553399px',
							'4503.19150970456px -1050.0919782005928px',
							'4496.533894253753px -1050.532555693661px',
							'4489.178697772253px -1051.1322306147815px',
							'4487.526532173248px -1051.6095228989386px',
							'4487.306243426714px -1051.7319055359021px',
							'4485.71526914619px -1051.9644325461325px',
							'4483.928482646525px -1052.1112917104886px',
							'4483.928482646525px -1052.1112917104886px',
							'4482.153934410556px -1051.3647576250119px',
							'4457.77531312745px -1037.9149058227365px',
							'4319.385027249259px -944.4512859738024px',
							'4319.385027249259px -944.4512859738024px',
							'3598.477865952768px -485.6510182617841px',
							'2596.959556362941px 138.74519552538484px',
							'2393.7309494215506px 315.02514580743855px',
							'2101.836122000191px 636.7201453293814px',
							'1811.4588392771775px 1072.9285782579595px',
							'1718.8518978869872px 1227.803805335118px',
							'1718.8518978869872px 1227.803805335118px',
							'1625.2291806100009px 1329.1366287407973px',
							'1566.2162730662587px 1303.925805526341px',
							'1449.916053159958px 1213.1790802179942px',
							'1214.3172387417535px 982.842719189215px',
							'932.7270293527106px 690.5929821206616px',
							'880.4818816330433px 639.9143321541256px',
							'880.4818816330433px 639.9143321541256px',
							'883.7862128310546px 658.2105363801511px',
							'917.1721961946648px 731.3953532842528px',
							'1037.829237976862px 873.9956018739841px',
							'1037.829237976862px 873.9956018739841px',
							'1053.4819772444785px 895.6206138254136px',
							'1045.1232431398796px 894.372310928387px',
							'1036.1525958504637px 889.7584855148675px',
							'1013.5485228033273px 875.6232909455971px',
							'983.4423941103356px 848.9316378238838px',
							'953.2505975714695px 811.6049335500526px',
							'881.2161774548235px 747.0725690792618px',
							'823.9533416196577px 689.014246103834px',
							'823.9533416196577px 689.014246103834px',
							'748.8960703700162px 623.6986327564777px',
							'728.3602638875609px 607.421742040348px',
							'728.3602638875609px 607.421742040348px',
							'688.8796252031743px 577.0586098097332px',
							'676.1885457500717px 567.6963380820346px',
							'668.6252987857348px 559.3987952959174px',
							'665.5167798068649px 553.0348981738216px',
							'661.612773687733px 547.4664881919878px',
							'657.1702839659623px 542.6690888230232px',
							'648.7748350702744px 536.941581413137px',
							'636.6589540108997px 533.5148675781624px',
							'631.0171144468878px 532.7928100200784px',
							'622.6828568696816px 532.2910412085286px',
							'616.3067214838894px 531.006023520413px',
							'612.525098001721px 530.2717276986327px',
							'609.1718137489244px 528.5828473085381px',
							'604.704847499761px 526.4289128979826px',
							'598.65914523377px 524.5931733435319px',
							'595.220193135099px 523.406061764987px',
							'594.4369442585333px 523.0878669088823px',
							'594.4369442585333px 523.0878669088823px',
							'624.4329285782579px 523.6875418300028px',
							'743.8783822545176px 529.4395257672818px',
							'825.629983746056px 535.167033177168px',
							'1086.806769289607px 595.7953915288268px',
							'1126.29964623769px 616.5270102304236px',
							'1142.3562482072855px 635.0190266755903px',
							'1154.0315517735921px 648.3097810498135px',
							'1167.0530643464958px 661.0253370303088px',
							'1204.8325843770915px 685.3672435223252px',
							'1236.2971603403766px 691.6087580074577px',
							'1236.2971603403766px 691.6087580074577px',
							'1236.2114924945024px 691.6087580074577px',
							'1235.4282436179367px 692.379768620327px',
							'1234.4002294674442px 691.9024763361698px',
							'1234.4002294674442px 691.9024763361698px',
							'1234.4002294674442px 691.9024763361698px',
							'1234.4002294674442px 691.9024763361698px',
							'1235.220193135099px 692.379768620327px',
							'1234.4002294674442px 691.9024763361698px',
							'1234.4002294674442px 691.9024763361698px',
							'1234.4002294674442px 691.9024763361698px',
							'1234.4002294674442px 691.9024763361698px',
							'1234.4002294674442px 691.9024763361698px',
							'1234.4002294674442px 691.9024763361698px',
							'1234.4002294674442px 691.9024763361698px',
							'1234.4002294674442px 691.9024763361698px',
							'1234.4002294674442px 691.9024763361698px',
							'1234.4002294674442px 691.9024763361698px',
							'1234.4002294674442px 691.9024763361698px',
							'1234.4002294674442px 691.9024763361698px',
							'1234.4002294674442px 691.9024763361698px',
							'1235.5139114638112px 692.379768620327px',
							'1237.5332249737069px 691.9024763361698px',
							'1237.5332249737069px 691.9024763361698px',
							'1237.5332249737069px 691.9024763361698px',
							'1237.5332249737069px 691.9024763361698px',
							'1237.5332249737069px 691.9024763361698px',
							'1237.5332249737069px 691.9024763361698px',
							'1237.5332249737069px 691.9024763361698px',
							'1237.5332249737069px 691.9024763361698px',
							'1237.5332249737069px 691.9024763361698px',
							'1237.5332249737069px 691.9024763361698px',
							'1237.5332249737069px 691.9024763361698px',
							'1237.5332249737069px 691.9024763361698px',
							'1237.5332249737069px 691.9024763361698px',
							'1237.5332249737069px 691.9024763361698px',
							'1246.8220671192275px 692.6979634764318px',
							'1260.2229658667177px 695.7452911368199px',
							'1261.397839181566px 696.0022946744431px',
							'1261.397839181566px 696.0022946744431px',
							'1243.7135481403575px 636.1449469356535px',
							'1243.7135481403575px 636.1449469356535px',
							'1263.0989578353572px 635.8634668706377px',
							'1279.6695668801988px 645.6418395640119px',
							'1296.435988144182px 651.3571087102017px',
							'1297.9045797877427px 652.4585524428721px',
							'1271.7758867960608px 655.1632087197629px',
							'1144.7549478917679px 653.0337508366px',
							'984.0787838225451px 631.1394970838512px',
							'984.0787838225451px 631.1394970838512px',
							'862.4549192083373px 600.8130796443254px',
							'807.9456927048475px 583.9487522707716px',
							'786.9815469930204px 578.1722918061px',
							'771.7816234821685px 573.3871307008318px',
							'697.8257959651975px 546.8790515345635px',
							'634.4927813366479px 528.0198871785066px',
							'617.7875513911464px 524.4218376517831px',
							'604.5702265991013px 523.3203939191127px',
							'595.293622717277px 523.3203939191127px',
							'587.7793288077254px 523.3203939191127px',
							'573.1301271632087px 523.1735347547567px',
							'569.5320776364853px 522.6595276795105px',
							'568.0022946744431px 520.4688784778659px',
							'567.9043885648723px 520.1262070943685px',
							'567.9043885648723px 520.1262070943685px',
							'567.0721866335214px 519.5877234917297px',
							'567.0721866335214px 519.5877234917297px',
							'567.0721866335214px 519.5877234917297px',
							'568.3449660579405px 520.1262070943685px',
							'582.480160627211px 520.1262070943685px',
							'589.9699780093699px 520.1262070943685px',
							'597.7902285113299px 520.1262070943685px',
							'602.13481212353px 520.1262070943685px',
							'608.143799598432px 520.1262070943685px',
							'622.7318099244669px 520.3342575772062px',
							'652.997036045511px 520.762596806578px',
							'682.8339229371833px 520.762596806578px',
							'729.0945597093412px 517.9233196290277px',
							'732.5947031264939px 517.4949803996558px',
							'749.6058896644039px 516.9075437422316px',
							'763.5697485419256px 515.2553781432259px',
							'776.8972177072378px 512.8444401950474px',
							'781.7068553398987px 511.5104694521465px',
							'781.7068553398987px 511.41256334257577px',
							'781.7068553398987px 511.25346591452336px',
							'781.7068553398987px 511.25346591452336px',
							'794.5325556936609px 511.5838990343245px',
							'794.5325556936609px 511.5838990343245px',
							'834.7107754087389px 512.5874366574242px',
							'835.4940242853045px 512.5874366574242px',
							'835.4940242853045px 512.5874366574242px',
							'835.3838799120375px 512.2692418013195px',
							'836.2283201070848px 511.86537909934026px',
							'855.3934410555503px 510.7394588392772px',
							'939.0909264748063px 508.80581317525576px',
							'1206.4113203939191px 503.8493163782388px',
							'1343.8959747585811px 498.80715173534753px',
							'1363.2324313987954px 498.5623864614208px',
							'1363.2324313987954px 498.5623864614208px',
							'1362.8530452242087px 497.6567549478918px',
							'1362.8530452242087px 497.6567549478918px',
							'1362.8530452242087px 497.6567549478918px',
							'1362.8530452242087px 497.6567549478918px',
							'1362.8530452242087px 497.6567549478918px',
							'1362.8530452242087px 497.6567549478918px',
							'1362.8530452242087px 497.6567549478918px',
							'1362.8530452242087px 497.6567549478918px',
							'1362.8530452242087px 497.6567549478918px',
							'1362.7796156420309px 498.5623864614208px',
							'1359.6221436083756px 498.5623864614208px',
							'1357.8231188450138px 498.5623864614208px',
							'1357.5294005163018px 498.5623864614208px',
							'1356.5870542116836px 497.6567549478918px',
							'1356.5870542116836px 497.6567549478918px',
							'1356.5870542116836px 497.6567549478918px',
							'1356.5870542116836px 497.6567549478918px',
							'1356.5870542116836px 497.6567549478918px',
							'1356.5870542116836px 497.6567549478918px',
							'1356.5870542116836px 497.6567549478918px',
							'1356.5870542116836px 497.6567549478918px',
							'1356.5870542116836px 497.6567549478918px',
							'1356.5870542116836px 497.6567549478918px',
							'1356.5870542116836px 497.6567549478918px',
							'1353.4540587054212px 497.6567549478918px',
							'1353.4540587054212px 497.6567549478918px',
							'1353.4540587054212px 497.6567549478918px',
							'1353.4540587054212px 497.6567549478918px',
							'1353.4540587054212px 497.6567549478918px',
							'1353.4540587054212px 497.6567549478918px',
							'1353.4540587054212px 497.6567549478918px',
							'1353.4540587054212px 497.6567549478918px',
							'1353.4540587054212px 497.6567549478918px',
							'1353.4540587054212px 497.6567549478918px',
							'1353.4540587054212px 497.6567549478918px',
							'1353.4540587054212px 497.6567549478918px',
							'1353.4540587054212px 497.6567549478918px',
							'1353.4540587054212px 497.6567549478918px',
							'1353.4540587054212px 497.6567549478918px',
							'1353.4540587054212px 497.6567549478918px',
							'1353.4540587054212px 497.6567549478918px',
							'1353.4540587054212px 497.6567549478918px',
							'1353.4540587054212px 497.6567549478918px',
							'1353.4540587054212px 497.6567549478918px',
							'1353.4540587054212px 497.6567549478918px',
							'1353.4540587054212px 497.6567549478918px',
							'1353.4540587054212px 497.6567549478918px',
							'1353.4540587054212px 497.6567549478918px',
							'1353.4540587054212px 497.6567549478918px',
							'1353.4540587054212px 497.6567549478918px',
							'1353.4540587054212px 497.6567549478918px',
							'1353.4540587054212px 497.6567549478918px',
							'1353.4540587054212px 497.6567549478918px',
							'1353.4540587054212px 497.6567549478918px',
							'1353.4540587054212px 497.6567549478918px',
							'1353.4540587054212px 497.6567549478918px',
							'1353.4540587054212px 497.6567549478918px',
							'1353.4540587054212px 497.6567549478918px',
							'1353.4540587054212px 497.6567549478918px',
							'1353.4540587054212px 497.6567549478918px',
							'1353.4540587054212px 497.6567549478918px',
							'1302.5551199923511px 530.4430633903814px',
							'1254.0671192274597px 557.7833444880008px',
							'1190.2568123147528px 594.1065111387322px',
							'1130.4361793670523px 615.890620518214px',
							'1103.352901807056px 625.6200401568027px',
							'1103.352901807056px 625.6200401568027px',
							'974.4962233483125px 640.7954871402619px',
							'930.4507123051917px 639.8898556267329px',
							'873.2245912611148px 630.3072951525003px',
							'841.3806291232431px 617.8976957644135px',
							'825.7278898556267px 608.9760015297829px',
							'777.2031742996462px 585.1725786404054px',
							'746.9746629696912px 578.2212448608853px',
							'704.8627975905919px 577.6827612582465px',
							'693.9829811645473px 575.8225451764031px',
							'666.6671765943207px 569.0303088249354px',
							'649.5458456831437px 563.363992733531px',
							'644.271154030022px 561.0631991586193px',
							'631.4454536762597px 554.6625872454346px',
							'619.9904388564872px 550.2690505784492px',
							'610.7750262931446px 546.8790515345635px',
							'600.3602638875609px 541.7267425184052px',
							'595.8443445836122px 539.2301367243522px',
							'592.6256812314753px 535.6565637250216px',
							'591.5976670809829px 533.6739650062148px',
							'591.5976670809829px 533.6739650062148px',
							'579.9101252509801px 525.9026675590401px',
							'569.8869872836791px 523.2347260732383px',
							'562.9234152404628px 519.9915861937087px',
							'561.883162826274px 518.9758103069126px',
							'561.0754374223158px 516.3445836122px',
							'560.8551486757816px 516.0998183382733px',
							'560.8551486757816px 516.0998183382733px',
							'560.8551486757816px 515.6347643178124px',
							'561.050960894923px 515.6347643178124px',
							'562.2258342097715px 515.7938617458648px',
							'564.343053829238px 515.8672913280428px',
							'568.8834496605793px 516.1732479204513px',
							'575.5043503202983px 516.1732479204513px',
							'575.5043503202983px 516.1732479204513px',
							'582.8105937470121px 516.5159193039487px',
							'592.0504828377474px 516.5159193039487px',
							'603.909360359499px 516.5159193039487px',
							'625.7424227937661px 517.066641170284px',
							'631.0660675016732px 517.066641170284px',
							'642.8637537049431px 516.6750167320012px',
							'647.9793479300124px 516.6505402046084px',
							'661.9064920164452px 517.0788794339803px',
							'677.4368486470981px 517.2746916531217px',
							'694.3011760206521px 517.9110813653313px',
							'703.4676355292092px 518.1068935844727px',
							'736.4987092456257px 518.5964241323262px',
							'736.4987092456257px 518.5964241323262px',
							'757.4261401663639px 519.5265321732479px',
							'763.9246581891194px 519.9181566115308px',
							'765.3320585141983px 519.9548714026198px',
							'770.7046562768907px 519.9548714026198px',
							'777.3867482550913px 520.4076871593843px',
							'784.1177932880772px 520.9951238168085px',
							'795.0955158236925px 521.55808394684px',
							'802.4507123051917px 521.8640405392484px',
							'807.0645377187111px 521.9741849125155px',
							'812.7553303375083px 522.4392389329764px',
							'817.197820059279px 522.7084807342958px',
							'818.0912133091117px 522.7329572616885px',
							'818.0912133091117px 522.7329572616885px',
							'826.3275647767473px 523.1980112821493px',
							'826.3275647767473px 523.1980112821493px',
							'827.943015584664px 523.2959173917201px',
							'831.528826847691px 523.2959173917201px',
							'836.2405583707812px 523.5406826656468px',
							'836.2405583707812px 523.5406826656468px',
							'841.9068744621857px 523.5406826656468px',
							'846.0311693278516px 523.5406826656468px',
							'847.8301940912133px 523.5406826656468px',
							'849.6536953819676px 523.8955923128406px',
							'852.0523950664499px 524.1770723778563px',
							'852.0523950664499px 524.1770723778563px',
							'853.7045606654556px 524.2137871689454px',
							'855.3934410555503px 524.2137871689454px',
							'857.3882780380534px 524.3851228606941px',
							'858.6732957261688px 524.7033177167989px',
							'859.8971220958026px 524.7277942441916px',
							'860.2642700066928px 524.7277942441916px',
							'860.8272301367243px 524.9113681996366px',
							'862.2591069891959px 525.1071804187781px',
							'862.5650635816044px 525.1071804187781px',
							'864.1193230710393px 525.4131370111866px',
							'864.3396118175734px 525.4131370111866px',
							'864.3396118175734px 525.4131370111866px',
							'866.5180227555215px 525.8414762405583px',
							'866.6281671287886px 525.8537145042548px',
							'867.2278420499092px 525.8537145042548px',
							'867.2278420499092px 525.8537145042548px',
							'867.2278420499092px 526.2331006788412px',
							'867.2278420499092px 526.2942919973228px',
							'867.2278420499092px 526.2942919973228px',
							'867.2278420499092px 525.829237976862px',
							'867.2278420499092px 525.829237976862px',
							'867.2645568409981px 525.829237976862px',
							'891.6064633330146px 525.829237976862px',
							'1068.1067023616024px 530.6266373458266px',
							'1226.3352136915576px 548.8983650444593px',
							'1431.4362749784875px 582.5413519456927px',
							'1708.8409981833827px 635.8634668706377px',
							'1708.8409981833827px 635.8634668706377px',
							'2021.0391050769672px 753.7913758485515px',
							'2283.6844822640787px 928.3824457405105px',
							'2283.6844822640787px 928.3824457405105px',
							'2449.659814513816px 1117.9898651878764px',
							'2470.6729132804285px 1144.6203269911082px',
							'2472.545367625968px 1146.639640501004px',
							'2472.545367625968px 1146.639640501004px',
							'2472.545367625968px 1147.2148388947319px',
							'2472.374031934219px 1153.2972559518118px',
							'2470.611721961947px 1174.7631704751889px',
							'2471.6152595850463px 1212.383593077732px',
							'2473.8181470503873px 1232.980590878669px',
							'2474.503489817382px 1242.1103355961372px',
							'2474.638110718042px 1245.6227172769864px',
							'2478.909264748064px 1258.1546993020365px',
							'2484.2696242470597px 1270.552060426427px',
							'2489.2505975714694px 1283.402237307582px',
						],
						{
							extrapolateLeft: 'clamp',
							extrapolateRight: 'clamp',
						},
					),
				}}
			/>
		</AbsoluteFill>
	);
};

const StudioPlaybackRateContent = () => {
	const {width, height} = useVideoConfig();
	const portrait = width < height;
	const focusX = portrait ? 640 : 720;
	return (
		<AbsoluteFill style={{backgroundColor: '#15161b', overflow: 'hidden'}}>
			<Interactive.Div
				name="Playback rate and changing clips - close-up"
				style={{
					position: 'absolute',
					width: 2560,
					height: 1278,
					left: '50%',
					top: '50%',
					translate: `${-focusX}px -480px`,
					transformOrigin: `${focusX}px 480px`,
					rotate: '-3deg',
					scale: portrait
						? width / 980
						: 2.3 * Math.min(width / 2560, height / 1600),
				}}
			>
				<StudioPlaybackRateCapture />
			</Interactive.Div>
		</AbsoluteFill>
	);
};

export const StudioPlaybackRateComposition = Interactive.create({
	Component: StudioPlaybackRateContent,
	layout: 'absolute-fill',
	schema: {},
});
